import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRightinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.8 3.298l1.401-1.426 5.514 5.415a1 1 0 0 1 0 1.426L6.2 14.128l-1.4-1.426L9.587 8 4.8 3.298z",
		fill: "currentColor"
	})
});
export default SvgChevronRightinline;
